import CloseButton from '@/shared/Buttons/CloseButton'
import css from './notification.module.css'
import { INotificationWsMessage } from '../../notifications.types'
import NotificationIcon from '../NotificationIcon'
import NotificationActions from '../NotificationActions'
import NotificationDescription from '../NotificationDescription'
import NotificationTitle from '../NotificationTitle'
import cn from '@/utils/cn'

interface IProps {
  notification: INotificationWsMessage
  onCancel: () => void
}

const Notification = (props: IProps) => {
  return (
    <div className={css.wrapper}>
      <div style={{ width: '24px', height: '24px' }}>
        <NotificationIcon notification={props.notification} />
      </div>
      <div className={css.closeIconWrapper}>
        <CloseButton onClick={props.onCancel} />
      </div>
      <div className="inline-flex-gap top">
        <div className="flex-lines gap4">
          <p className={cn(css.title, 'text-heading-5')}>
            <NotificationTitle notification={props.notification} />
          </p>
          <p className="text-nm" style={{ whiteSpace: 'pre-line' }}>
            <NotificationDescription notification={props.notification} />
          </p>
          <div className="inline-flex-gap gap8 mt12">
            <NotificationActions notification={props.notification} onCancel={props.onCancel} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Notification
